module.exports = __webpack_public_path__ + "img/anverso.957c1720.svg";